var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-menu",
    {
      staticClass: "elevation-1 c-button-menu",
      attrs: {
        "offset-y": "",
        origin: "center center",
        "nudge-bottom": 14,
        transition: "slide-y-transition"
      },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function({ on }) {
            return [
              _c(
                "v-btn",
                _vm._g(
                  { staticClass: "c-button-toolbar", attrs: { text: "" } },
                  on
                ),
                [
                  _c(
                    "v-badge",
                    { attrs: { color: "red", overlap: "" } },
                    [
                      _c("span", { attrs: { slot: "badge" }, slot: "badge" }, [
                        _vm._v(_vm._s(_vm.unreadCount))
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-icon",
                        { attrs: { color: "opposite", medium: "" } },
                        [_vm._v("notifications")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]
          }
        }
      ])
    },
    [
      _vm._v(" "),
      _c(
        "v-card",
        { staticClass: "elevation-0", attrs: { color: "opposite" } },
        [
          _c(
            "v-card-title",
            { attrs: { dense: "" } },
            [
              _c("h4", [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.generateMessage("boilerplate.notifications.title")
                    ) +
                    "\n      "
                )
              ]),
              _vm._v(" "),
              _c("v-switch", {
                staticClass: "ml-5",
                attrs: { label: "Uniquement les non lues" },
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                  }
                },
                model: {
                  value: _vm.displayUnreadItems,
                  callback: function($$v) {
                    _vm.displayUnreadItems = $$v
                  },
                  expression: "displayUnreadItems"
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "pl-6" },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "" },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.refreshCountNotifications()
                        }
                      }
                    },
                    [_c("v-icon", [_vm._v("refresh")])],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("v-divider"),
          _vm._v(" "),
          _vm.isLoading
            ? _c("v-progress-linear", { attrs: { indeterminate: "" } })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "v-card-text",
            { staticClass: "pa-0" },
            [
              _c(
                "v-list",
                { staticClass: "pa-0 menu-list", attrs: { "two-line": "" } },
                [
                  _vm._l(_vm.filteredItems, function(item, index) {
                    return [
                      _c(
                        "v-list-item",
                        { key: index },
                        [
                          _c(
                            "v-icon",
                            {
                              staticClass: "mr-2",
                              attrs: { color: "primary" }
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(item.icon || "person") +
                                  "\n            "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list-item-content",
                            {
                              class: { "lightgrey--text": item.read === "O" },
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.handleClick(item)
                                }
                              }
                            },
                            [
                              _c(
                                "v-list-item-title",
                                { staticClass: "text-caption" },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(item.message_datetime) +
                                      "\n                "
                                  ),
                                  item.read === "N"
                                    ? _c(
                                        "v-icon",
                                        {
                                          staticClass: "float-right",
                                          attrs: {
                                            "x-small": "",
                                            color: "primary"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                  fiber_manual_record\n                "
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-list-item-subtitle",
                                {
                                  class: { clickable: item.link },
                                  on: {
                                    click: function($event) {
                                      return _vm.goTo(item.link)
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "font-weight-bold" },
                                    [_vm._v(_vm._s(item.topic_name))]
                                  ),
                                  _vm._v(" "),
                                  _c("truncate-text-with-hover", {
                                    class: {
                                      "lightgrey--text": item.read === "O"
                                    },
                                    attrs: { text: item.message, length: 30 }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]
                  })
                ],
                2
              ),
              _vm._v(" "),
              _c("v-divider"),
              _vm._v(" "),
              _c(
                "v-btn",
                { staticClass: "ma-0", attrs: { block: "", text: "" } },
                [_vm._v("All")]
              ),
              _vm._v(" "),
              _c("v-divider")
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }